import { isOfType } from '../../../../ts-utils';
export const isMarkable = isOfType([
    'COMMENT_READY',
    'COMMENT_EDITING',
    'COMMENT_UPDATE_PENDING',
    'COMMENT_UPDATE_ERROR',
    'COMMENT_DELETE_PENDING',
    'REPLY_READY',
    'REPLY_EDITING',
    'REPLY_UPDATE_PENDING',
    'REPLY_UPDATE_ERROR',
    'REPLY_DELETE_PENDING',
]);
//# sourceMappingURL=mark-types.js.map